import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileEventsConfig } from '@v2/pages/productionOrder/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ProductionOrderDetailsNCFileEventsStack = createStackNavigator();

const ProductionOrderDetailsNCFileEventsNavigator = (props: any) => {
  return (
    <ProductionOrderDetailsNCFileEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileEventsConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsNCFileEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </ProductionOrderDetailsNCFileEventsStack.Navigator>
  );
};

export { ProductionOrderDetailsNCFileEventsNavigator };
